
export default function LocationSection() {
  const steps = [
    {
      step: '1',
      title: 'Desde Santa Marta',
      description: 'Toma un bus o taxi hacia El Zaino (45 minutos)',
      icon: 'ri-bus-line'
    },
    {
      step: '2',
      title: 'Entrada El Zaino',
      description: 'Paga la entrada al Parque Tayrona',
      icon: 'ri-ticket-line'
    },
    {
      step: '3',
      title: 'Transporte interno',
      description: 'Camina o toma transporte hasta Castilletes (15 min)',
      icon: 'ri-walk-line'
    },
    {
      step: '4',
      title: '¡Llegaste!',
      description: 'Disfruta tu paraíso frente a la playa',
      icon: 'ri-map-pin-line'
    }
  ];

  const handleMapClick = () => {
    window.open('https://www.google.com/maps/d/viewer?mid=1o6cw7QDUw3SD2YUXzny1D_YhrykGDO0&ll=11.298590545589022%2C-73.93546080703736&z=14', '_blank');
  };

  return (
    <section className="py-20 bg-gradient-to-b from-amber-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
            Cómo Llegar al Alojamiento
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Te guiamos paso a paso para que llegues sin complicaciones a tu paraíso
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="relative mb-6">
                <div className="w-16 h-16 bg-amber-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
                  {step.step}
                </div>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                {step.title}
              </h3>
              <p className="text-gray-600">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        {/* Map Image */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="p-6 bg-teal-600 text-white">
            <h3 className="text-2xl font-bold mb-2">Ubicación Exacta</h3>
            <p className="text-teal-100">Castilletes, Parque Nacional Natural Tayrona</p>
          </div>
          <div className="relative h-96 group cursor-pointer" onClick={handleMapClick}>
            <img
              src="https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/65ca00f4233f9f648a8ded6ce468e1e4.png"
              alt="Mapa Parque Tayrona"
              className="w-full h-full object-contain"
            />
            <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <button className="bg-teal-600 hover:bg-teal-7 text-white px-8 py-4 rounded-lg font-semibold text-lg shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center gap-3 whitespace-nowrap">
                <i className="ri-map-pin-line text-2xl"></i>
                Click para interactuar en el mapa
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
